import { useSearchParams } from 'react-router-dom';

import { usePodDetailsNavigateBackFromSubRoute } from './usePodDetailsNavigateBackFromSubRoute';

const MEMBERS_PANEL_QUERY = 'podMembers';
const FOLLOWERS_PANEL_QUERY = 'podFollowers';

export function useMembersPanel() {
    const [searchParams, setSearchParams] = useSearchParams();
    const { handleNavigateBackFromSubRoute } = usePodDetailsNavigateBackFromSubRoute();
    const groupId = searchParams.get(MEMBERS_PANEL_QUERY);

    function openPanel(id: string) {
        searchParams.set(MEMBERS_PANEL_QUERY, id);
        setSearchParams(searchParams);
    }

    function closePanel() {
        searchParams.delete(MEMBERS_PANEL_QUERY);
        setSearchParams(searchParams);
        handleNavigateBackFromSubRoute();
    }

    return {
        open: Boolean(groupId),
        groupId,
        openPanel,
        closePanel,
    };
}

export function useFollowersPanel() {
    const [searchParams, setSearchParams] = useSearchParams();
    const groupId = searchParams.get(FOLLOWERS_PANEL_QUERY);

    function openPanel(id: string) {
        searchParams.set(FOLLOWERS_PANEL_QUERY, id);
        setSearchParams(searchParams);
    }

    function closePanel() {
        searchParams.delete(FOLLOWERS_PANEL_QUERY);
        setSearchParams(searchParams);
    }

    return {
        open: Boolean(groupId),
        groupId,
        openPanel,
        closePanel,
    };
}
